import { Button, Container, Divider, Typography } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { EkkoLogo } from 'src/Common/Components/EkkoLogo';
import StyledFormAccordion from 'src/Common/Components/Forms/StyledFormAccordion';
import { CenteredColumn, ReactiveRow } from 'src/Common/Components/Stacks';

export const ErrorFallbackComponent = ({ error, resetErrorBoundary }: FallbackProps): React.JSX.Element => (
  <Container maxWidth={'sm'} sx={{ p: 10 }}>
    <CenteredColumn spacing={2}>
      <EkkoLogo width={260} height={92} />
      <Typography variant={'h3'} fontWeight={500} color={'error'}>
        something went wrong
      </Typography>
      <Divider sx={{ pb: 2 }} />
      <Typography variant={'h3'} fontStyle={'italic'}>
        {`"${error.message}"`}
      </Typography>
      <StyledFormAccordion label={'trace'}>
        <Typography color={'InfoText'}>{error.stack}</Typography>
      </StyledFormAccordion>
      <ReactiveRow sx={{ pt: 2 }}>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={() => {
            resetErrorBoundary();
          }}
        >
          {'retry'}
        </Button>
        <Button
          variant="contained"
          color={'primary'}
          onClick={() => {
            window.location.reload();
          }}
        >
          {'reload'}
        </Button>
        <Button variant="contained" color={'error'} onClick={() => window.location.assign('/logout')}>
          {'logout'}
        </Button>
      </ReactiveRow>
    </CenteredColumn>
  </Container>
);
